// traceability: requirements: [NFR-008]
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-950">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-6 sm:flex-row sm:px-6 lg:px-8">
        <p className="text-sm text-zinc-500 dark:text-zinc-400">
          {t('footer.copyright', { year: String(year) })}
        </p>
        <nav className="flex items-center gap-6" aria-label="Footer navigation">
          <Link
            to="/privacy"
            className="text-sm text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
          >
            {t('footer.privacy')}
          </Link>
          <Link
            to="/terms"
            className="text-sm text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
          >
            {t('footer.terms')}
          </Link>
          <Link
            to="/contact"
            className="text-sm text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
          >
            {t('footer.contact')}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
